const filter = require('lodash/filter')
const { hook: globalHook, utils: globalUtils } = require('js/global/module')

module.exports = [
  '$rootScope', 'composeService', 'mailFolderService', '$cookies', '$stateParams', 'User', 'globalFolderService', 'contactService', 'wechatService', '$q', '$loading', '$utils', '$translate',
  function ($rootScope, composeService, mailFolderService, $cookies, $stateParams, User, globalFolderService, contactService, wechatService, $q, $loading, $utils, $translate) {
    $loading.show()

    // 1. 清理上个账户的缓存
    composeService.clearAccountCache()
    mailFolderService.clearFolders()
    wechatService.clearCache()

    // const sid = $location.$$search.sid || $cookies.get('Coremail.sid')
    const isSSO = $cookies.get('Coremail.sso') === '1' || location.pathname.indexOf('/sso.html') !== -1

    // 2. 登录成功获取新账户的信息
    return $q.resolve().then(_ => { // 登录检查（单点和普通登录都会带上sid）
      const sid = $stateParams.sid
      if (sid) return sid

      console.log('---customSSO---')
      const defer = $q.defer()
      globalHook.exec('customSSO', res => {
        defer.resolve(res || sid)
      }).catch(_ => {
        defer.resolve(sid)
      })
      return defer.promise
    }).then(sid => { // 初始化用户信息（同时兼具下发cookie的任务）
      if (!sid || !/^[a-zA-Z]+$/.test(sid)) {
        console.warn('---$stateParams.sid was invalid---', $stateParams) // 单点或刷新的情况会触发
        isSSO && $utils.$notify.set({ message: $translate.instant('CODE.GLOBAL.INVALID_SSO_SID') })
        return ''
      }

      console.log('---getUserAttrs---', sid)
      User.updateSid(sid)
      return User.getAttrs().then(_ => {
        $rootScope.$emit('LOGIN.SUCCESS')
        User.updateMailboxAccounts({}, true)
        $cookies.remove('Coremail.sso', { path: '/' })
      })
    }).then(_ => { // 检查是否有重定向需求
      const redirectUrl = $stateParams.redirectUrl
      if (!redirectUrl) return

      console.log('---redirectUrl---', redirectUrl)
      const oUser = User.getCurrentUser()
      return oUser.getCToken().then(cToken => {
        const url = globalUtils.setQueryParams(redirectUrl, {sid: oUser.sid, cToken})
        console.log('getCToken success: ', cToken, redirectUrl, url)
        location.replace(url)
      })
    }).then(_ => { // 初始化应用的数据
      console.log('---initAppData---')

      const promises = [globalFolderService.getAllFolders()]
      if ($rootScope.settings.settingMenu.sharedMailbox) {
        promises.push(User.getSharedMailAccounts())
      }
      if ($rootScope.settings.mail.stranger.enable) {
        promises.push(contactService.getCachedPabContacts())
        promises.push(contactService.getCacheTrustedDomains())
      }
      if ($rootScope.settings.wxwork.enable && $utils.$misc.MD.isWorkWeChat) {
        // 如果是企业微信环境，强制返回附件的精准大小和使用免cookie下载
        $rootScope.settings.featureControl.read.enableAttachmentDecodedSize = true
        $rootScope.settings.featureControl.read.enableAttachmentDownloadByToken = true
        const {hideOptionMenu, jsApiList} = $rootScope.settings.wxwork
        promises.push(
          wechatService.config(jsApiList).then(res => {
            console.log('wxworkConfig res', res)

            // https://developers.weixin.qq.com/community/enterprisewechat/doc/00082ccaf48f086e2d8a268cd51000
            // checkJsApi 结果不是十分准确，这里仅提示，不做限制
            const checkJsApi = wechatService.convertToPromise(window.wx.checkJsApi)
            checkJsApi({jsApiList}).then(res => {
              console.log('checkJsApi res', res)
              const checkResult = (res && res.checkResult) || {}
              const isNotSupport = filter(jsApiList, item => !checkResult[item])
              const tipMessage = $translate.instant('TIPS.WXWORK_CHECKJSAPI_FAIL', {jsapi: isNotSupport.join(',')})
              isNotSupport.length && console.log(tipMessage)
            })
            // 是否需要禁用分享
            hideOptionMenu && window.wx.hideOptionMenu()
            globalHook.exec('handleWxWorkConfigReady')
          }).catch(err => {
            globalHook.exec('handleWxWorkConfigError', err)
            return $q.reject(err)
          })
        )
      }
      return $q.all(promises)
    }).finally(_ => {
      $loading.hide()
    }).catch(err => {
      console.log('frameInit error', err)
      $utils.$notify.set({ message: globalUtils.print(err), duration: 4000 })
      return $q.reject(err)
    })
  }
]



// WEBPACK FOOTER //
// ./src/js/controllers/frameInitCtrl.js